module.exports = __webpack_public_path__ + "img/squares_orange.b2aa2d4e.svg";